/** @format */

import {SensorCategoriesCriteriaType} from 'types';

import {SensorGroupType} from '../../types';

const getSensorGroup = (
  sensorGroups: SensorGroupType,
  categoryName: SensorCategoriesCriteriaType,
): string[] => {
  switch (categoryName) {
    case 'critical':
      return [...sensorGroups.red];
    case 'normal':
      return [...sensorGroups.yellow];
    case 'low':
      return [...sensorGroups.gray];
    default:
      throw new Error('Unsupported category name');
  }
};

export {getSensorGroup};
